<template>
  <div>
    <Header @toggle-drawer="sideNav = !sideNav" />

    <v-navigation-drawer
      v-model="sideNav"
      app
      clipped
      elevation="4"
      color="#1A237E"
      dark
      width="270"
    >
      <v-list dense nav class="mt-4 px-2">
        <template v-for="(main, i) in menus">
          
          <v-list-group
            :key="i"
            :prepend-icon="main.icon"
            active-class="blue-gradient-active"
            color="white"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="sidebar-title">
                  {{ main.name }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(sub, j) in main.subMenu"
              :key="j"
              :to="sub.route"
              active-class="submenu-active"
              class="rounded-lg mb-1"
              exact
            >
              <v-list-item-content>
                <v-list-item-title class="sidebar-subtext">
                  {{ sub.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main class="main-content-bg">
      <v-container fluid class="pa-8">
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Header from '../../common/appHeader'

export default {
  components: { Header },
  data() {
    return {
      sideNav: true,
      menus: [
        { 
          name: "Dashboard", 
          icon: "mdi-view-dashboard-outline",
          subMenu: [{ name: "Overview", route: "/admin" }] 
        },
        { 
          name: "User Management", 
          icon: "mdi-account-group-outline",
          subMenu: [
            { name: "All Users", route: "/admin/userlist" },
          ] 
        },
        { 
          name: "Compliance", 
          icon: "mdi-shield-check-outline",
          subMenu: [{ name: "Privacy Policy", route: "/admin/privacy" }] 
        },
        { 
          name: "Analytics", 
          icon: "mdi-chart-bar",
          subMenu: [{ name: "Reports", route: "/admin/reports" }] 
        },
      ],
    };
  }
};
</script>

<style scoped>
/* Main Content Background */
.main-content-bg {
  background-color: #F8FAFC; /* Soft, modern slate grey */
  min-height: 100vh;
}

/* Sidebar Styling */
.sidebar-title {
  font-family: 'Syne', sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.8rem !important;
  letter-spacing: 1.2px;
  color: rgba(255, 255, 255, 0.7);
}

.sidebar-subtext {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 0.85rem !important;
}

/* Navigation Item Active States */
.submenu-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #64B5F6 !important; /* Soft Light Blue instead of Yellow */
}

/* Customizing the list group icon color */
::v-deep .v-list-group__header.v-list-item--active .v-list-item__icon {
  color: white !important;
}

/* Modernizing the Scrollbar for the Drawer */
::v-deep .v-navigation-drawer__content::-webkit-scrollbar {
  width: 5px;
}
::v-deep .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}
</style>